type ShowPermissionErrorFn = (message?: string) => void;

class PermissionErrorModalSingleton {
  private showErrorFn: ShowPermissionErrorFn | null = null;

  register(fn: ShowPermissionErrorFn) {
    this.showErrorFn = fn;
  }

  showError(message?: string) {
    if (this.showErrorFn) {
      this.showErrorFn(message);
    } else {
      console.error('PermissionErrorModal not registered');
    }
  }

  unregister() {
    this.showErrorFn = null;
  }
}

export const permissionErrorModalSingleton = new PermissionErrorModalSingleton();
